import { ui } from "../utils/ui";

const displayCodeValidity = (
  isValid: boolean,
  codeValidity: HTMLParagraphElement
) => {
  ui.formInputError ? (ui.formInputError.innerHTML = "") : null;
  if (isValid) {
    codeValidity.innerHTML = "Code valide";
    codeValidity.classList.remove("is-invalid");
  } else {
    codeValidity.innerHTML =
      "Le code renseigné n’est pas correct, veuillez réessayer.";
    codeValidity.classList.add("is-invalid");
  }
};

export default displayCodeValidity;